import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = '',
  size = 'md'
}: PriceDisplayProps) {
  const [currencySymbol, setCurrencySymbol] = useState('$');
  useEffect(() => {
    // Simulate Shopify Markets currency detection based on browser locale
    const locale = navigator.language || 'en-US';
    const lowerLocale = locale.toLowerCase();
    if (lowerLocale.startsWith('es-mx')) {
      setCurrencySymbol('MX$');
    } else if (lowerLocale.startsWith('en-gb')) {
      setCurrencySymbol('£');
    } else if (['de', 'fr', 'it', 'es-es'].some(l => lowerLocale.startsWith(l))) {
      setCurrencySymbol('€');
    } else {
      setCurrencySymbol('$');
    }
  }, []);
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl',
    xl: 'text-5xl md:text-6xl'
  };
  return <div className={`flex items-baseline gap-3 ${className}`} data-id="element-94">
      {originalAmount && <span className="text-espresso-700/60 line-through text-lg md:text-xl font-medium" data-id="element-95">
          {currencySymbol}
          {originalAmount.toFixed(2)}
        </span>}
      <span className={`font-bold text-cta-600 ${sizeClasses[size]}`} data-id="element-96">
        {currencySymbol}
        {amount.toFixed(2)}
      </span>
    </div>;
}